// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__2BiGZ","icon":"LinkComponent_icon__1uWxH"};